<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees>

	<div *ngIf="beneficiaire" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ beneficiaire.firstName + ' ' + beneficiaire.lastName }}</span
					>
				</div>

				<div class="">
					<a
						*ngIf="isDeletable"
						(click)="openModal(deleteBeneficiaire)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="rounded bg-light">
			<div *ngIf="isFormReadOnly">
				<div class="row my-2">
					<div class="col-7">
						<label for="inputAddresse" class="form-label fw-bold"
							>Adresse</label
						>
						<span class="form-control-plaintext">{{
							beneficiaire?.address?.label
						}}</span>
					</div>
					<div class="col-5" *ngIf="isSESSAD">
						<label for="beneficiaireCompetence" class="form-label fw-bold"
							>Compétences</label
						>
						<span class="form-control-plaintext">
							{{ getBeneficiaireSkillsAsString(beneficiaire) }}
						</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col">
						<label class="form-label fw-bold">Centre de soin</label>
						<span class="form-control bg-transparent border-light ps-0">{{
							beneficiaire.serviceCenter.name
						}}</span>
					</div>
					<div class="col">
						<div class="col-6" *ngIf="isAreaActive">
							<span
								for="area"
								class="theme-main-color fw-bold form-label row my-2"
								>Secteur
							</span>
							<span class="row my-2" id="area"
								>{{
									beneficiaire.area ? beneficiaire.area.name : 'Non spécifié'
								}}
							</span>
						</div>
					</div>
				</div>
				<div class="row my-4">
					<div class="col">
						<label for="department" class="theme-main-color fw-bold form-label"
							>Service(s)
						</label>
						<span class="d-block my-2" id="department">
							<span
								*ngIf="
									beneficiaire.centerDepartments &&
									beneficiaire.centerDepartments.length
								"
							>
								<ul>
									<li *ngFor="let department of beneficiaire.centerDepartments">
										{{ department.name }}
									</li>
								</ul>
							</span>
							<span
								*ngIf="
									!beneficiaire.centerDepartments ||
									beneficiaire.centerDepartments.length === 0
								"
							>
								Non spécifié
							</span>
						</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-6">
						<label for="beneficiairePhone" class="form-label fw-bold"
							>Téléphone</label
						>
						<span class="form-control-plaintext">{{
							beneficiaire?.phone
						}}</span>
					</div>
					<div class="col-6">
						<label for="beneficiaireEmail" class="form-label fw-bold"
							>Email</label
						>
						<span class="form-control-plaintext">{{
							beneficiaire?.email
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col">
						<label
							class="form-label fw-bold"
							*ngIf="
								beneficiaire.preferredEmployee1 ||
								beneficiaire.preferredEmployee2 ||
								beneficiaire.preferredEmployee3
							"
							>{{ labelIntervenantCapitalized }}(s) préféré(s)
						</label>
						<span
							class="form-control bg-transparent border-light ps-0"
							*ngIf="beneficiaire.preferredEmployee1"
							>{{
								beneficiaire.preferredEmployee1?.firstName +
									' ' +
									beneficiaire.preferredEmployee1?.lastName
							}}</span
						>
						<span
							class="form-control bg-transparent border-light ps-0"
							*ngIf="beneficiaire.preferredEmployee2"
							>{{
								beneficiaire.preferredEmployee2?.firstName +
									' ' +
									beneficiaire.preferredEmployee2?.lastName
							}}</span
						>
						<span
							class="form-control bg-transparent border-light ps-0"
							*ngIf="beneficiaire.preferredEmployee3"
							>{{
								beneficiaire.preferredEmployee3?.firstName +
									' ' +
									beneficiaire.preferredEmployee3?.lastName
							}}</span
						>
					</div>
					<div class="col">
						<label
							class="form-label fw-bold"
							*ngIf="
								beneficiaire.incompatibleEmployee1 ||
								beneficiaire.incompatibleEmployee2 ||
								beneficiaire.incompatibleEmployee3
							"
							>{{ labelIntervenantCapitalized }}(s) incompatible(s)
						</label>
						<span
							class="form-control bg-transparent border-light ps-0"
							*ngIf="beneficiaire.incompatibleEmployee1"
							>{{
								beneficiaire.incompatibleEmployee1?.firstName +
									' ' +
									beneficiaire.incompatibleEmployee1?.lastName
							}}</span
						>
						<span
							class="form-control bg-transparent border-light ps-0"
							*ngIf="beneficiaire.incompatibleEmployee2"
							>{{
								beneficiaire.incompatibleEmployee2?.firstName +
									' ' +
									beneficiaire.incompatibleEmployee2?.lastName
							}}</span
						>
						<span
							class="form-control bg-transparent border-light ps-0"
							*ngIf="beneficiaire.incompatibleEmployee3"
							>{{
								beneficiaire.incompatibleEmployee3?.firstName +
									' ' +
									beneficiaire.incompatibleEmployee3?.lastName
							}}</span
						>
					</div>
				</div>
			</div>
			<app-beneficiaire-form
				*ngIf="!isFormReadOnly"
				[beneficiaire]="beneficiaire"
				[isAddForm]="false"
				[form]="form"
				[isAddressSelected]="isAddressSelected"
				[isAddressDefault]="isAddressDefault"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
			>
			</app-beneficiaire-form>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm()"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!form.valid || isValidateButtonClicked.value"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>

	<div *ngIf="beneficiaire" class="my-4">
		<div class="row my-5">
			<span class="theme-main-color fw-bold fs-5"
				>{{ labelInterventionPluralizedCapitalized }} programmées</span
			>
		</div>
		<div class="my-2">
			<div
				*ngFor="
					let missionRqEmp of pairMissionRqEmployee
						| sortByMissionDate : sortOrder
						| paginate : { itemsPerPage: 5, currentPage: currentPage }
						| orderBy : 'missionRequest.date' : sortOrder
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailFormation(missionRqEmp.missionRequest)"
			>
				<div class="col-lg-2 col-10">
					<span class="align-middle">
						{{ missionRqEmp.employeeName }}
					</span>
				</div>
				<div class="col-lg-2 col-10">
					<span class="align-middle">{{
						missionRqEmp.missionRequest.missionType?.type
					}}</span>
				</div>
				<div class="col-lg col" *ngIf="isSESSAD">
					<span class="align-middle">{{
						missionRqEmp.missionRequest.careSpecialty?.name
					}}</span>
				</div>
				<div class="col-lg-3 col-10" *ngIf="isSESSAD">
					<span class="align-middle">
						{{
							getMissionPlaceNameAndAddress(missionRqEmp.missionRequest)
						}}</span
					>
				</div>
				<div class="col-lg-2 col-10">
					<span class="align-middle"
						>{{ missionRqEmp.missionRequest.date | date : 'dd/MM/YYYY' }},
						{{ missionRqEmp.missionRequest.readyTime | minutesToTime }} -
						{{ missionRqEmp.missionRequest.dueTime | minutesToTime }}</span
					>
				</div>
				<div class="col-1 ms-lg-auto hand-cursor">
					<i
						class="fs-4 bi bi-caret-right-fill mb-1 align-middle"
						aria-hidden="true"
					></i>
				</div>
			</div>

			<div class="row my-4">
				<pagination-controls
					class="d-flex justify-content-center"
					(pageChange)="currentPage = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				></pagination-controls>
			</div>
		</div>
	</div>

	<ng-template #deleteBeneficiaire>
		<div class="modal-header text-center">
			<h4>Suppression {{ labelBeneficiaireCapitalized }}</h4>
			<button
				type="button"
				class="btn-close pull-right"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="confirmDeleteModalRef.hide()"
			></button>
		</div>
		<div class="modal-body">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</div>
		<div class="modal-footer">
			<a
				(click)="confirmDeleteModalRef.hide()"
				class="btn theme-main-color-button"
				>Retour</a
			>
			<a class="btn theme-red-button ms-3" (click)="delete(beneficiaire)"
				>Supprimer</a
			>
		</div>
	</ng-template>
</div>
